import { styled, css, Tooltip, Inline, AlertDangerIcon } from 'canoe';
import React, { Fragment, useContext } from 'react';

import { LayerContext } from '../context/LayerContext';

const DropInsideZone = styled.div<{ offset?: string }>`
  ${({ theme, offset }) => css`
    width: 100%;
    padding: 0;
    transition: ${theme.transitions.default()};

    ${offset &&
    css`
      margin-left: ${theme.spaces.s};
    `}

    & > div {
      transition: ${theme.transitions.default()};
      width: 100%;
    }
    &.show {
      padding: 1px 0;
    }
    &.expand {
      padding: 6px 0;
      & > div {
        height: 2px;
        background: ${theme.colors.ParadiseRedL30};
      }

      &.isDroppable > div {
        background: ${theme.colors.BrandPurpleL30};
      }

      &.isOver {
        & > div {
          background: ${theme.colors.Danger};
        }

        &.isDroppable > div {
          background: ${theme.colors.BrandPurple};
        }
      }
    }
  `}
`;

export type DropZoneProps = {
  nodeId: string;
  position: 'inside' | 'after';
};
export const DropZone = React.memo(({ nodeId, position }: DropZoneProps) => {
  const { draggedNodeIds, dropZones, hoveredDropZones, targetedDropZone } = useContext(
    LayerContext,
  );
  const gestureToEvaluate = position === 'after' ? 'canDropAfter' : 'canDropIn';
  const displayToEvaluate = position === 'after' ? 'showDropAfter' : 'showDropIn';
  const isDroppable = dropZones[nodeId]?.[gestureToEvaluate] === true;

  const shouldExpand = hoveredDropZones[nodeId]?.[displayToEvaluate];
  const isOver = targetedDropZone === `${nodeId}_${position}`;

  const classNames = `${draggedNodeIds.length ? 'show' : ''} ${shouldExpand ? 'expand' : ''} ${
    isOver ? 'isOver' : ''
  } ${isDroppable ? 'isDroppable' : ''}`.trim();

  return (
    <Tooltip
      state="danger"
      placement="right"
      trigger="manual"
      visible={!isDroppable && isOver}
      content={
        !isDroppable ? (
          <Inline space="none" align="center">
            <AlertDangerIcon size="s" color="White" mr="xs" />
            {dropZones[nodeId]?.[gestureToEvaluate]}
          </Inline>
        ) : (
          <Fragment />
        )
      }
    >
      <DropInsideZone
        data-cy={`dropzone-${nodeId}-${position}`}
        offset={(position === 'inside').toString()}
        data-dropzone-id={nodeId}
        data-dropzone-position={position}
        className={classNames}
      >
        <div />
      </DropInsideZone>
    </Tooltip>
  );
});
